import type { IconData } from '@stacksjs/iconify-core'

export const callHangUpRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M3.414.586A2 2 0 1 0 .586 3.414l44 44a2 2 0 1 0 2.828-2.828l-8.853-8.854A33.37 33.37 0 0 0 46.983 14.6q.017-.132.017-.267V13c0-6.627-5.372-12-12-12h-.568a5 5 0 0 0-4.643 3.143l-2.466 6.165a6 6 0 0 0 1.328 6.471l3.049 3.048a18 18 0 0 1-3.136 5.909zM16.78 28.652a6 6 0 0 0-6.47-1.328L4.142 29.79A5 5 0 0 0 1 34.432v.57c0 6.627 5.373 12 12 12h.5a33.35 33.35 0 0 0 18.12-5.32a2 2 0 0 0-2.167-3.362A29.35 29.35 0 0 1 13.5 43H13a8 8 0 0 1-8-8v-.569a1 1 0 0 1 .629-.928l6.165-2.466a2 2 0 0 1 2.157.442l3.076 3.077c.97.97 2.44 1.433 3.874.998a22 22 0 0 0 2.518-.937a2 2 0 0 0-1.623-3.656q-.958.425-1.968.738z\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default callHangUpRemix
